/**
 * Deepgram Text to Speech Voices - https://developers.deepgram.com/docs/tts-models
 * Response Formats - https://developers.deepgram.com/docs/tts-media-output-settings#audio-format-combinations
 * todo sample rate and bitrate can be added in the response format
 **/
import { SpeakSchema } from '../../backend_node_modules/@deepgram/SpeakSchema'

export type DeepgramVoice = 'alloy' | 'luna' | 'stella' | 'athena' | 'hera' | 'orion' | 'arcas' | 'perseus' | 'angus' | 'orpheus' | 'helios' | 'zeus'
export const DeepgramVoice: { [key in DeepgramVoice]: string } = {
  alloy: "Asteria (female) (English (US))",
  luna: "Luna (female) (English (US))",
  stella: "Stella (female) (English (US))",
  athena: "Athena (female) (English (UK))",
  hera: "Hera (female) (English (US))",
  orion: "Orion (male) (English (US))",
  arcas: "Arcas (male) (English (US))",
  perseus: "Perseus (male) (English (US))",
  angus: "Angus (male) (English (Ireland))",
  orpheus: "Orpheus (male) (English (US))",
  helios: "Helios (male) (English (UK))",
  zeus: "Zeus (male) (English (US))",
}
export type DeepgramResponseFormat = SpeakSchema["encoding"]
export const DeepgramResponseFormat:{ [key in DeepgramResponseFormat]: string } = {
  // --id for OpenAI-- : --label for frontend--
  linear16: "Linear16",
  mulaw: "MuLaw",
  alaw: "ALaw",
  mp3: "MP3",
  opus: "Opus",
  flac: "FLAC",
  aac: "AAC",
}